import styled from 'styled-components';
import { H1, H2, B1, SectionParent, BlueButton } from '../StyledComponents';
import { navigate } from '@reach/router';
import React from 'react';
import { Title } from '../Esper/HomePage/HomepageSectionOne';
import tick from '../../assets/v2/Pricing/PricingTick.svg';

const HeadingSection = styled(Title)`
  color: #ffffff;
  padding-top: 2rem;
  padding-bottom: 2rem;
`;
const SectionOne = styled(SectionParent)`
  /* background: linear-gradient(to bottom, #ffffff 10%, #232a57 30%, transparent 20%, #f8fafd 50%); */
  background-image: linear-gradient(
    to bottom,
    #ffffff,
    #ffffff 5%,
    #232a57 3%,
    #232a57 27%,
    #f8fafd 27%
  );
  padding-bottom: 5rem;
  padding-top: 10rem !important;
  text-align: center;
  @media (max-width: 1680px) and (min-width: 1200px) {
    padding: 0 14rem;
    padding-bottom: 5rem;
  }
  @media (max-width: 950px) and (min-width: 700px) {
    padding: 0 14rem;
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
    background-image: linear-gradient(
      to bottom,
      #ffffff,
      #ffffff 2%,
      #232a57 2%,
      #232a57 27%,
      #f8fafd 27%
    );
  }
  @media (max-width: 520px) {
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;
const TableContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  margin-top: 2rem;
  width: 100%;
  @media (max-width: 950px) {
    grid-template-columns: repeat(3, 1fr);
    margin-top: -1rem;
    width: 100%;
  }
  @media (max-width: 550px) {
    margin-top: 0rem;
  }
`;

const TableColumns = styled.div`
  display: grid;
  border-radius: 8px;
  grid-column: span 4;
  margin-top: 2.5rem;
  width: 95%;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.15);
  background-color: #ffffff;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-right: 0;
    width: 100%;
    margin-top: 2.5rem !important;
  }
`;

const TopSectionHeader = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  padding-top: 42px;
  padding-bottom: 2px;
`;

const TopSubHeaderText = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #626679;
`;
const TopSubHeaderTextStyled = styled(TopSubHeaderText)`
  min-height: 2.5rem;
  margin-top: -1.5rem;
`;
const HighlightedTextContainer = styled.div`
  min-height: 7rem;
  display: grid;
  justify-content: center;
  align-items: start;
  margin-top: 1rem;
`;
const HighlightedText = styled.div`
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  text-align: center;
  padding-bottom: 1.5rem;
`;

const HighlightedTextBottom = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 4.14;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  padding-bottom: 1rem;
  text-align: center;
  margin-top: -2.5rem;
`;
const BoxTop = styled.div`
  grid-row: span 1;
  display: grid;
  align-content: center;
  height: 2.5rem;
  text-align: center;
  border-radius: 8px 8px 0 0;
  background-image: linear-gradient(to left, #9869d2, #745dbe 70%);
`;
const BoxTopFree = styled(BoxTop)`
  background-image: linear-gradient(to right, #49ab8e, #66d1b1);
`;
const BoxTopContent = styled.div`
  height: 2rem;
  display: grid;
  align-items: end;
  color: white;
`;
const LicenseSection = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  background: #f8fbff;
  margin-top: 1rem;
  padding: 1rem;
`;

const LicenseText = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #755dbf;
`;

const BlueButtonWrapper = styled.div`
  margin-top: 1rem;
  justify-content: center;
  display: grid;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
`;
const BlueButtonBlack = styled(BlueButton)`
  border: 1px solid black;
  padding: 1rem;
  font-family: 'Nunito Sans', sans-serif;
  color: black;
  padding-bottom: 1rem;
  background: white;
  background-color: white;
  height: fit-content;
  box-shadow: none;
  width: 18rem;
  @media (max-width: 1400px) {
    width: 13rem;
  }
  @media (max-width: 768px) {
    width: 15rem;
  }
`;
const BlueButtonQuote = styled(BlueButton)`
  padding: 1rem;
  font-family: 'Nunito Sans', sans-serif;
  color: #4d5a6d;
  padding-bottom: 1rem;
  background: #ecf1f8;
  height: fit-content;
  box-shadow: none;
  width: 18rem;
  @media (max-width: 1400px) {
    width: 13rem;
  }
  @media (max-width: 768px) {
    width: 15rem;
  }
`;

const PointSection = styled.div`
  display: block;
  padding-left: 60px;
`;
const PointList = styled.ul`
  /* margin-left: 40px; */
  padding-left: 0.5em;
  list-style: none;
  font-size: 15px;
  margin-left: 1rem;
`;

const PointListItem = styled.li`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #979797;
  padding: 2px 0;
  background-size: 18px;
  background-position-y: center;
  list-style: disc;
  text-align: left;
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;
const PointListItemHeader = styled.li`
  background-position-y: 4px;
  text-indent: 5px;
  margin-left: 44px;
  list-style: url(${tick});
  text-align: left;
  margin-top: 1rem;
`;
const BlueButtonPurple = styled(BlueButton)`
  padding: 1rem;
  font-family: 'Nunito Sans', sans-serif;
  color: white;
  padding-bottom: 1rem;
  height: fit-content;
  box-shadow: none;
  width: 18rem;
  @media (max-width: 1400px) {
    width: 13rem;
  }
  @media (max-width: 768px) {
    width: 15rem;
  }
`;
const TableBottomContent = styled.div`
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  padding: 1rem 3rem;
`;
export default class PricingsectionOne extends React.Component<any, any> {
  render() {
    return (
      <SectionOne>
        <HeadingSection>
          {this.props?.messages?.PricingPageHeroText}
        </HeadingSection>
        <TableContainer>
          <TableColumns style={{ marginTop: '0rem' }}>
            <BoxTop>
              <BoxTopContent>
                {this.props?.messages?.PricingPagePopular}
              </BoxTopContent>
            </BoxTop>
            <TopSectionHeader>
              {this.props?.messages?.PricingPagePro}
            </TopSectionHeader>
            <TopSubHeaderText>
              {this.props?.messages?.PricingPageProFor}
            </TopSubHeaderText>
            <HighlightedTextContainer>
              <HighlightedText>$4</HighlightedText>
              <HighlightedTextBottom>
                {this.props.messages?.PricingPagePerDevicePerMonth}
              </HighlightedTextBottom>
            </HighlightedTextContainer>
            <TopSubHeaderTextStyled>
              {this.props?.messages?.PricingPageProMin1000Devices} <br />
              {this.props.messages?.PricingPageBilledAnnually}
            </TopSubHeaderTextStyled>
            <BlueButtonWrapper>
              {/*<BlueButtonPurple
                id="pricing__try_it_now_2"
                onClick={() =>
                  navigate(
                    this.props.messages?.locale !== 'en'
                      ? `/${this.props.messages?.locale}/signup`
                      : '/signup'
                  )
                }
              >
                {this.props.messages?.PricingPageTryNowCTA}
              </BlueButtonPurple>*/}
              <BlueButtonPurple
                id="pricing__get_a_custom_quote_2"
                onClick={() =>
                  navigate(
                    this.props.messages?.locale !== 'en'
                      ? `/${this.props.messages?.locale}/contact-us`
                      : '/contact-us'
                  )
                }
              >
                {this.props.messages?.PricingPageQuoteCTA}
              </BlueButtonPurple>
            </BlueButtonWrapper>
            <LicenseSection>
              <LicenseText style={{ color: '#755dbf' }}>
                {this.props?.messages?.PricingPageProLicense}
              </LicenseText>
              <LicenseText style={{ color: '#151828' }}>
                {this.props?.messages?.PricingPageProStorage}
              </LicenseText>
            </LicenseSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesAppManage}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageApps}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageUpdate}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageInstall}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDeviceManage}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceManageActions}
                </PointListItem>
                <PointListItem>
                  {
                    this.props.messages
                      ?.PricingPageFeaturesDeviceManageNotifications
                  }
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceManageActivity}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDeviceGrp}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceGrpCommand}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceGrpInstall}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesRemote}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteView}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteControl}{' '}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteDebug}{' '}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDevTools}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsDevice}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsSDK}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsAPI}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsConsole}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsPlugin}{' '}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDevops}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesKiosk}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesReports}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesGeofencing}
            </PointListItemHeader>
            <LicenseSection
              style={{ background: '#66d1b1', padding: '0.5rem' }}
            >
              <LicenseText style={{ color: '#ffffff' }}>
                {this.props?.messages?.PricingPageProSupport}
              </LicenseText>
            </LicenseSection>
            <TableBottomContent>
              *{this.props?.messages?.PricingPageGMSAOSPSupport}
            </TableBottomContent>
          </TableColumns>
          <TableColumns>
            <TopSectionHeader>
              {this.props?.messages?.PricingPageEssentials}{' '}
            </TopSectionHeader>
            <TopSubHeaderText>
              {this.props?.messages?.PricingPageEssentialsFor}
            </TopSubHeaderText>
            <HighlightedTextContainer>
              <HighlightedText>$3</HighlightedText>
              <HighlightedTextBottom>
                {this.props.messages?.PricingPagePerDevicePerMonth}
              </HighlightedTextBottom>
            </HighlightedTextContainer>
            <TopSubHeaderTextStyled>
              {this.props?.messages?.PricingPageEssentialsMin100Devices}
              <br /> {this.props.messages?.PricingPageBilledAnnually}
            </TopSubHeaderTextStyled>
            <BlueButtonWrapper>
              <BlueButtonBlack
                id="pricing__try_it_now_3"
                onClick={() =>
                  navigate(
                    this.props.messages?.locale !== 'en'
                      ? `/${this.props.messages?.locale}/signup`
                      : '/signup'
                  )
                }
              >
                {this.props?.messages?.PricingPageTryNowCTA}
              </BlueButtonBlack>
              {/*<BlueButtonQuote
                id="pricing__get_a_custom_quote_3"
                onClick={() =>
                  navigate(
                    this.props.messages?.locale !== 'en'
                      ? `/${this.props.messages?.locale}/contact-us`
                      : '/contact-us'
                  )
                }
              >
                {this.props?.messages?.PricingPageQuoteCTA}
              </BlueButtonQuote>*/}
            </BlueButtonWrapper>
            <LicenseSection>
              <LicenseText style={{ color: '#755dbf' }}>
                {this.props?.messages?.PricingPageEssentialsLicense}
              </LicenseText>
              <LicenseText style={{ color: '#151828' }}>
                {this.props?.messages?.PricingPageEssentialsStorage}
              </LicenseText>
            </LicenseSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesAppManage}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageApps}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageUpdate}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageInstall}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDeviceManage}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceManageActions}
                </PointListItem>
                <PointListItem>
                  {
                    this.props.messages
                      ?.PricingPageFeaturesDeviceManageNotifications
                  }
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceManageActivity}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDeviceGrp}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceGrpCommand}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceGrpInstall}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesRemote}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteView}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteControl}{' '}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteDebug}{' '}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDevTools}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsDevice}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsSDK}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsAPI}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsConsole}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsPlugin}{' '}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDevops}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesKiosk}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesReports}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesGeofencing}
            </PointListItemHeader>
            <LicenseSection
              style={{ background: '#66d1b1', padding: '0.5rem' }}
            >
              <LicenseText style={{ color: '#ffffff' }}>
                {this.props?.messages?.PricingPageEssentialsEmailSupport}
              </LicenseText>
            </LicenseSection>
            <TableBottomContent>
              *{this.props?.messages?.PricingPageGMSAOSPSupport}
            </TableBottomContent>
          </TableColumns>
          <TableColumns style={{ marginTop: '0rem' }}>
            <BoxTopFree>
              <BoxTopContent>
                {this.props?.messages?.PricingPageFree}
              </BoxTopContent>
            </BoxTopFree>
            <TopSectionHeader>
              {this.props?.messages?.PricingPageStarter}
            </TopSectionHeader>
            <TopSubHeaderText>
              {this.props?.messages?.PricingPageStartrerFor}
            </TopSubHeaderText>
            <HighlightedTextContainer>
              <HighlightedText>$0</HighlightedText>
              <HighlightedTextBottom>
                {this.props?.messages?.PricingPageStarter100Devices}
              </HighlightedTextBottom>
            </HighlightedTextContainer>
            <TopSubHeaderTextStyled style={{ color: '#66d1b1' }}>
              {this.props?.messages?.PricingPageStarterNoCreditCard}
            </TopSubHeaderTextStyled>
            <BlueButtonWrapper>
              <BlueButtonBlack
                id="pricing__try_it_now"
                onClick={() =>
                  navigate(
                    this.props.messages?.locale !== 'en'
                      ? `/${this.props.messages?.locale}/signup`
                      : '/signup'
                  )
                }
              >
                {this.props?.messages?.PricingPageTryNowCTA}
              </BlueButtonBlack>
              {/*<BlueButtonQuote
                id="pricing__get_a_custom_quote"
                onClick={() =>
                  navigate(
                    this.props.messages?.locale !== 'en'
                      ? `/${this.props.messages?.locale}/contact-us`
                      : '/contact-us'
                  )
                }
              >
                {this.props?.messages?.PricingPageQuoteCTA}
              </BlueButtonQuote>*/}
            </BlueButtonWrapper>
            <LicenseSection>
              <LicenseText style={{ color: '#755dbf' }}>
                {this.props?.messages?.PricingPageStarterLicense}
              </LicenseText>
              <LicenseText style={{ color: '#151828' }}>
                {this.props?.messages?.PricingPageStarterStorage}
              </LicenseText>
            </LicenseSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesAppManage}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageApps}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageUpdate}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesAppManageInstall}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDeviceManage}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceManageActions}
                </PointListItem>
                <PointListItem>
                  {
                    this.props.messages
                      ?.PricingPageFeaturesDeviceManageNotifications
                  }
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceManageActivity}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDeviceGrp}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceGrpCommand}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDeviceGrpInstall}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesRemote}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteView}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteControl}{' '}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesRemoteDebug}{' '}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDevTools}
            </PointListItemHeader>
            <PointSection>
              <PointList>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsDevice}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsSDK}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsAPI}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsConsole}
                </PointListItem>
                <PointListItem>
                  {this.props.messages?.PricingPageFeaturesDevToolsPlugin}{' '}
                </PointListItem>
              </PointList>
            </PointSection>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesDevops}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesKiosk}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesReports}
            </PointListItemHeader>
            <PointListItemHeader>
              {this.props.messages?.PricingPageFeaturesGeofencing}
            </PointListItemHeader>{' '}
            <LicenseSection style={{ padding: '0.5rem' }}>
              <LicenseText style={{ color: '#151828' }}>
                {this.props?.messages?.PricingPageStarterSupport}
              </LicenseText>
            </LicenseSection>
            <TableBottomContent>
              *{this.props?.messages?.PricingPageGMSAOSPSupport}
            </TableBottomContent>
          </TableColumns>
        </TableContainer>
      </SectionOne>
    );
  }
}
